<script setup lang="ts">
import type { CarouselI18nItem } from '~/types/elementsUi'

const { tm, baseKey } = useI18n('components.templates.sections.how-can-you-help-section')

const roleItems = computed<CarouselI18nItem[]>(() => tm('.items') as CarouselI18nItem[])
</script>

<template>
  <VSection :base-key="baseKey" title=".title">
    <template #content>
      <VCarousel
        v-slot="{ item }"
        :items="roleItems"
        :number-of-items="{ mobile: 1, tablet: 2, desktop: 3 }"
        loop
        dots
        class="mt-4"
        sr-label=".carousel-aria-label"
      >
        <VCard class="h-full rounded-xl">
          <template #content>
            <h3 class="title mb-0! text-h3">
              {{ item.title }}
            </h3>
            <p class="font-semibold text-gray-600 dark:text-gray-200">
              {{ item.subtitle }}
            </p>
            <p class="my-4">
              {{ item.description }}
            </p>
            <VButton width="full" class="mt-4 mb-2" :to="{ name: item.link_DNT as any }">
              {{ item.button }}
            </VButton>
          </template>
        </VCard>
      </VCarousel>
    </template>
  </VSection>
</template>

<style scoped></style>
